<template>
  <div :class="`as-parent-lineups as-parent-lineups-${siteName}`">
    <TabsBtn
      :tabs="tabs"
      :activeTab="activeTab"
      @change="changeTab"
      :isShowBorder="true"
    />

    <div class="as-scrolling as-scrolling__have-tab as-scrolling__result-popup">
      <Squad
        v-if="lineups"
        v-show="activeTab === 'squad'"
        :match="match"
        :lineups="lineups"
        :startingPlayers="startingPlayers[1].data"
      />
      <SquadEmpty v-else-if="activeTab === 'squad'" />

      <Players
        v-show="activeTab === 'players'"
        :match="match"
        :lineups="lineups"
        :startingPlayers="startingPlayers[0].data"
      />

      <InjuriesSuspensions
        v-show="activeTab === 'injuries_suspensions'"
        :match="match"
        :lineups="lineups"
        :startingPlayers="startingPlayers[2].data"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineProps, ref, computed } from "vue";
import type { ILineups, IMatch, IPlayer } from "~src/interfaces";
import Squad from '~src/components/lineups/Squad.vue';
import SquadEmpty from '~src/components/lineups/SquadEmpty.vue';
import Players from '~src/components/lineups/Players.vue';
import InjuriesSuspensions from '~src/components/lineups/InjuriesSuspensions.vue';
import TabsBtn from "~src/components/TabsBtn.vue";
import { usecommonStore } from "~src/stores/CommonStore";
const commonStore = usecommonStore();

interface IProps {
  lineups: ILineups;
  match: IMatch;
}

const props = withDefaults(defineProps<IProps>(), {});
const siteName = computed(() => commonStore.getSiteName);
const activeTab = ref("squad");

const tabs = [
  {
    title: "Sơ đồ",
    key: "squad",
  },
  {
    title: "Ra sân",
    key: "players",
  },
  {
    title: "Chấn thương & treo giò",
    key: "injuries_suspensions",
  },
];

const changeTab = (val: string) => {
  activeTab.value = val;
};

const startingPlayers = computed(() => {
  let result = [
    {
      type: "Starting Lineups",
      data: { home: <Array<IPlayer>>[], away: <Array<IPlayer>>[] },
    },
    { type: "Substitutes", data: { home: [], away: [] } },
    { type: "Injured or suspended", data: { home: [], away: [] } },
  ];
  try {
    let flag = false;
    try {
      const lineupSideHome = props.lineups?.lineup?.home || null;
      if (lineupSideHome) {
        for (const player of lineupSideHome) {
          if (player.first === 1) {
            result[0].data.home.push(player);
            flag = true;
          } else if ([-1, 2, 3].indexOf(player.first) === -1) {
            result[1].data.home.push(player);
            flag = true;
          }
        }
      }
      const lineupSideAway = props.lineups?.lineup?.away || null;
      if (lineupSideAway) {
        for (const player of lineupSideAway) {
          if (player.first === 1) {
            result[0].data.away.push(player);
            flag = true;
          } else if ([-1, 2, 3].indexOf(player.first) === -1) {
            result[1].data.away.push(player);
            flag = true;
          }
        }
      }

      if (props.lineups && props.lineups.injury.home) {
        result[2].data.home = props.lineups.injury.home;
        flag = true;
      }
      if (props.lineups && props.lineups.injury.away) {
        result[2].data.away = props.lineups.injury.away;
        flag = true;
      }
    } catch (e) {
      console.error(e);
    }
  } catch (error) {
    console.log(error);
  }

  return result;
});

</script>

<script lang="ts">
export default {};
</script>
